import { serviceName } from '../resources/serviceConstants';
import {
  PROJECT_DETAILS,
} from '../resources/endPoint';

export const getProjectDetails = (employeeId) => {
  // API call to fetch project details of users
  const url = employeeId ? `${PROJECT_DETAILS}?employeeId=${employeeId}` : PROJECT_DETAILS;

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.DARPAN_BRIDGE_MS,
    timeout: 180000,
  };
};
